export const PRODUCT_KEYS = {
  PASSPORT_OCR: 'PCS_PR',
  AADHAAR_OCR: 'PCS_AOCR',
  EMIRATES_ID_OCR: 'PCS_EIDOCR',
  PAN_CARD_OCR: 'PCS_PCOCR',
  AADHAAR_MASK: 'PCS_AMASK',
  VOTER_ID_OCR: 'PCS_VIDOCR',
  MALAYSIAN_VOTER_ID_OCR: 'PCS_MVIDOCR',
  MALAYSIAN_DRIVING_LICENSE_OCR: 'PCS_MDLOCR',
  MEXICAN_ID_OCR: 'PCS_MIDOCR',
  UAE_VISA_OCR: 'PCS_UVOCR',
};

export const PCSKey = {
  PCS: 'PCS001',
};
